import { licensedProductPhoto, representativeLaddoPhoto } from "@/lib/productImages";

export const ProductImageCredit = ({ product, context }) => {
  const photo = licensedProductPhoto(product);
  if (!photo && (product.image_source === "ai_generated" || representativeLaddoPhoto(product))) {
    return <p className="mt-2 text-[10px] leading-relaxed text-muted-foreground" data-testid={`${context}-photo-credit-${product.id}`}>AI-generated representative image</p>;
  }
  // Attribute this specific photograph, not any future owner-uploaded image.
  if (!photo) return null;

  return (
    <p className="mt-2 text-[10px] leading-relaxed text-muted-foreground" data-testid={`${context}-photo-credit-${product.id}`}>
      Representative photo: {" "}
      <a
        href={photo.source}
        target="_blank"
        rel="noopener noreferrer"
        title={`Photograph by ${photo.author}, via Wikimedia Commons`}
        className="underline underline-offset-2 transition-colors hover:text-terracotta"
        data-testid={`${context}-photo-source-${product.id}`}
      >{photo.author}</a>
      {" · "}
      <a
        href="https://creativecommons.org/licenses/by-sa/4.0/"
        target="_blank"
        rel="license noopener noreferrer"
        className="underline underline-offset-2 transition-colors hover:text-terracotta"
        data-testid={`${context}-photo-license-${product.id}`}
      >CC BY-SA 4.0</a>
      {" (resized / WebP)"}
    </p>
  );
};